import { MultiStepFormState } from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form-item';
import {
  MultiStepFormProvider,
  SubmitHandlerWithDirtyFields,
} from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form.provider';
import { GetRolesPaginatedModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/roles/models/inputs/get-roles-paginated.model';
import { SubmitErrorHandler } from 'react-hook-form';

import { useFilterRoleListContext } from '../../role.context';
import { RoleListFilterFormStep1Controller } from '../role-list-filter-form-step-1/role-list-filter-form-step-1.controller';

export interface RoleListFilterFormControllerProps {
  onError: SubmitErrorHandler<GetRolesPaginatedModel>;
  onSubmit: SubmitHandlerWithDirtyFields<GetRolesPaginatedModel>;
  onCancel: () => void;
  state: MultiStepFormState;
}

export const RoleListFilterFormController = (
  props: RoleListFilterFormControllerProps,
): React.JSX.Element => {
  const { onError, onSubmit, onCancel, state } = props;
  const data = useFilterRoleListContext();

  return (
    <MultiStepFormProvider<GetRolesPaginatedModel>
      useFormProps={{
        mode: 'all',
        defaultValues: data,
      }}
      submitErrorHandler={onError}
      submitHandler={onSubmit}
      onCancel={onCancel}
      state={state}
      items={[
        {
          fields: ['customerId', 'networkId'],
          component: <RoleListFilterFormStep1Controller />,
        },
      ]}
    />
  );
};
